import { render } from "./etkinlikCard.vue?vue&type=template&id=554560a0"
import script from "./etkinlikCard.vue?vue&type=script&lang=js"
export * from "./etkinlikCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__